interface ActionTypes {
  GET_TEAMS_START: string;
  GET_TEAMS_SUCCESS: string;
  GET_TEAMS_FAILURE: string;
}

export const TeamLocalActionTypes: ActionTypes = {
  GET_TEAMS_START: '@@GET_TEAMS_START',
  GET_TEAMS_SUCCESS: '@@GET_TEAMS_SUCCESS',
  GET_TEAMS_FAILURE: '@@GET_TEAMS_FAILURE'
};

export interface TeamLocalState {
  teams: any[];
  loading?: boolean;
}
